
import { Tarif_Course } from "./Tarif_Course.class";

/**
 * @classdesc Liste des tarifs d'une course
 * @kind class
 * @export
 * @prop {Tarif_Course[]} list - Liste des tarifs de la course
 * @class List_Tarifs_Course
 */
export class List_Tarifs_Course {
    list = [];
    /**
     * Creates an instance of List_Tarifs_Course.
     * @constructs
     * @kind function
     * @memberof List_Tarifs_Course
     */
    constructor() { }

    set(data) {
        for (let i = 0; i < data.list.length; i++) {
            let tarif = new Tarif_Course();
            tarif.set(data.list[i]);
            this.list.push(tarif);
        }
    }

    get_base_tarif() {
        let base_tarif;
        for (let i = 0; i < this.list.length; i++) {
            if (!this.list[i].has_limitations()) {
                if (base_tarif == null) {
                    base_tarif = this.list[i];
                }
                else {
                    if (this.list[i].get_default_price() > base_tarif.get_default_price())
                        base_tarif = this.list[i];
                }
            }
        }
        if (base_tarif == null) base_tarif = this.list[0];
        return base_tarif;
    }

    get_default_tarif_price() {
        let default_tarif = this.list[0];
        return default_tarif.get_default_price();
    }

    get_default_tarif_on_home(list_courses = []) {
        let default_tarif;
        for (let i = 0; i < this.list.length; i++) {

            let tarif = this.list[i];

            if (tarif.has_limitations()) {

                continue;
            };
            if (tarif.has_limitation_nb_inscrits()) {
                const current_list_courses = list_courses ? list_courses : [];
                if (!tarif.has_places_disponibles(current_list_courses)) {
                    continue;
                }
            }
            if (default_tarif == null) {
                default_tarif = tarif;
            }
            else {
                if (tarif.get_default_price() < default_tarif.get_default_price()) {
                    default_tarif = tarif;
                }
            }

        }

        if (default_tarif == null) default_tarif = this.list[0];
        if (default_tarif.has_majorations()) {
            return Math.max(default_tarif.get_majoration_price(), default_tarif.prix);
        }

        return default_tarif.prix;
    }

    has_upcoming_majorations() {
        let default_tarif = this.list[0];
        return default_tarif.has_upcoming_majoration();
    }

    get_current_price_for_inscription(coureur, list_courses, inscription = null, nom_course = "") {

        let base_tarif = this.get_base_tarif(); // Tarif de base : le plus cher des tarifs sans limitations
        let prix = base_tarif.get_default_price();

        let id_tarif = base_tarif.id;
        for (let i = 0; i < this.list.length; i++) {

            let tarif = this.list[i];

            let limitation_tarif = tarif.has_limitations(); // Limitations du tarif (age, sexe, etc.)
            let limitation_nb_inscrits_tarif = tarif.has_limitation_nb_inscrits(); // Limitation du nombre d'inscrits

            if (parseInt(prix) < parseInt(tarif.prix)) { // Si le prix du tarif est plus cher que le prix actuel, on passe au tarif suivant
                continue;
            }
            let coureur_match_limitations = true;
            let coureur_match_limitations_nb_inscrits = true;
            if (limitation_nb_inscrits_tarif) { // Si le tarif a une limitation du nombre d'inscrits
                coureur_match_limitations_nb_inscrits = tarif.has_places_disponibles(list_courses);

                // On vérifie qu'il reste des places disponibles
            }
            if (limitation_tarif) { // Si le tarif a des limitations
                coureur_match_limitations = tarif.coureur_match_limitations(limitation_tarif, coureur, inscription, nom_course); // On vérifie que le coureur match les limitations

            }
            if (coureur_match_limitations && coureur_match_limitations_nb_inscrits) { // Si le coureur match les limitations et qu'il reste des places disponibles
                prix = Math.min(prix, tarif.get_default_price());
                id_tarif = tarif.id;
            }
        }
        return [prix, id_tarif];
    }



}